module.exports = __webpack_public_path__ + "img/wp-screenshot@1x.2a886e47.jpg";